'use strict';
var optimizeCall = require('./optimizeCall');

var optimizeMouseMoveCall = optimizeCall();
window.addEventListener('mousemove', optimizeMouseMoveCall.call);

function dragDelegate(onMove, onEnd) {
  var startPosition;
  var delta;
  var isMoving = false;
  var onMoveProxy = function (e) {
    if (!startPosition) {
      startPosition = {
        pageX: e.pageX,
        pageY: e.pageY
      };
    }
    delta = {
      x: e.pageX - startPosition.pageX,
      y: e.pageY - startPosition.pageY
    };
    if (!isMoving) {
      if (Math.abs(delta.x) >= 5 || Math.abs(delta.y) >= 5) {
        isMoving = true;
      }
    }
    if (isMoving) {
      onMove(e, delta);
    }
  };
  var onEndProxy = function (e) {
    document.body.removeEventListener('mouseup', onEndProxy);
    optimizeMouseMoveCall.remove(onMoveProxy);
    onEnd(e, delta, isMoving);
  };
  document.body.addEventListener('mouseup', onEndProxy);
  optimizeMouseMoveCall.add(onMoveProxy);
}

/**
 * get mouse position in a node and page
 * @param node
 * @param e
 * @returns {{x: *, y: *, pageX: *, pageY: *}}
 */
function getMousePosition(node, e) {
  var boundingRect = node.getBoundingClientRect();
  return {
    x: e.pageX - boundingRect.left + node.scrollLeft,
    y: e.pageY - boundingRect.top + node.scrollTop,
    pageX: e.pageX,
    pageY: e.pageY
  }
}

module.exports = {
  dragDelegate: dragDelegate,
  getMousePosition: getMousePosition,
  onMove: function (cb) {
    optimizeMouseMoveCall.add(cb);
  },
  offMove: function (cb) {
    optimizeMouseMoveCall.remove(cb);
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/osx-scrollview/dist/mouseHelper.js
// module id = 223
// module chunks = 0